<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!-- content-header component -->
    <!-- <app-content-header [contentHeader]="contentHeader"></app-content-header> -->

    <!-- Basic Alerts start -->
    <div class="row match-height">
      <!-- Medal Card -->

      <!--/ Medal Card -->

      <!-- Analytics Cards -->
      <div class="col-xl-12 col-md-12 col-12">
        <div class="card card-statistics">
          <div class="card-header">
            <h4 class="card-title">Dashboard Analytics</h4>
            <div class="d-flex align-items-center">
              <p class="card-text font-small-2 mr-25 mb-0" *ngIf="lastUpdated">Last updated: {{ lastUpdated | date:'medium' }}</p>
            </div>
          </div>
          <div class="card-body statistics-body">
            <div class="row">
              <!-- Admin View -->
              <ng-container *ngIf="isAdmin">
                <!-- Calls -->
                <div class="col-sm-6 col-xl-3 mb-2 mb-xl-0">
                  <div class="media">
                    <div class="avatar bg-light-danger mr-2">
                      <div class="avatar-content">
                        <i data-feather="phone-call" class="avatar-icon"></i>
                      </div>
                    </div>
                    <div class="media-body my-auto">
                      <h4 class="font-weight-bolder mb-0">{{ overview?.calls?.total || 0 }}</h4>
                      <p class="card-text font-small-3 mb-0">Total Calls</p>
                      <small>Active: {{ overview?.calls?.active || 0 }}</small><br>
                      <small>Avg Duration: {{ overview?.calls?.avgDuration | msToMinutes }}</small><br>
                      <small>Total Duration: {{ overview?.calls?.totalDuration | msToMinutes }}</small>
                    </div>
                  </div>
                </div>
                <!-- Customers -->
                <div class="col-sm-6 col-xl-3 mb-2 mb-xl-0">
                  <div class="media">
                    <div class="avatar bg-light-info mr-2">
                      <div class="avatar-content">
                        <i data-feather="users" class="avatar-icon"></i>
                      </div>
                    </div>
                    <div class="media-body my-auto">
                      <h4 class="font-weight-bolder mb-0">{{ overview?.customers?.total || 0 }}</h4>
                      <p class="card-text font-small-3 mb-0">Total Customers</p>
                      <small>Active: {{ overview?.customers?.active || 0 }}</small><br>
                      <small>New Today: {{ overview?.customers?.newToday || 0 }}</small>
                    </div>
                  </div>
                </div>
                <!-- Users -->
                <div class="col-sm-6 col-xl-3 mb-2 mb-sm-0">
                  <div class="media">
                    <div class="avatar bg-light-primary mr-2">
                      <div class="avatar-content">
                        <i data-feather="user" class="avatar-icon"></i>
                      </div>
                    </div>
                    <div class="media-body my-auto">
                      <h4 class="font-weight-bolder mb-0">{{ overview?.users?.total || 0 }}</h4>
                      <p class="card-text font-small-3 mb-0">Total Users</p>
                      <small>Active: {{ overview?.users?.active || 0 }}</small><br>
                      <small>Online: {{ overview?.users?.online || 0 }}</small>
                    </div>
                  </div>
                </div>
                <!-- Departments -->
                <div class="col-sm-6 col-xl-3">
                  <div class="media">
                    <div class="avatar bg-light-success mr-2">
                      <div class="avatar-content">
                        <i data-feather="home" class="avatar-icon"></i>
                      </div>
                    </div>
                    <div class="media-body my-auto">
                      <h4 class="font-weight-bolder mb-0">{{ departmentStats.length }}</h4>
                      <p class="card-text font-small-3 mb-0">Departments</p>
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- Agent View -->
              <ng-container *ngIf="!isAdmin">
                <!-- Total Calls -->
                <div class="col-sm-6 col-xl-3 mb-2 mb-xl-0">
                  <div class="media">
                    <div class="avatar bg-light-danger mr-2">
                      <div class="avatar-content">
                        <i data-feather="phone-call" class="avatar-icon"></i>
                      </div>
                    </div>
                    <div class="media-body my-auto">
                      <h4 class="font-weight-bolder mb-0">{{ overall?.totalCalls || 0 }}</h4>
                      <p class="card-text font-small-3 mb-0">Total Calls</p>
                      <small>Ongoing: {{ overall?.ongoingCalls || 0 }}</small><br>
                      <small>Completed: {{ overall?.completedCalls || 0 }}</small><br>
                      <small>Failed: {{ overall?.failedCalls || 0 }}</small>
                    </div>
                  </div>
                </div>
                <!-- Call Durations -->
                <div class="col-sm-6 col-xl-3 mb-2 mb-xl-0">
                  <div class="media">
                    <div class="avatar bg-light-info mr-2">
                      <div class="avatar-content">
                        <i data-feather="clock" class="avatar-icon"></i>
                      </div>
                    </div>
                    <div class="media-body my-auto">
                      <h4 class="font-weight-bolder mb-0">{{ overall?.avgCallDuration | msToMinutes }}</h4>
                      <p class="card-text font-small-3 mb-0">Average Duration</p>
                      <small>Max: {{ overall?.maxCallDuration | msToMinutes }}</small><br>
                      <small>Total: {{ overall?.totalDuration | msToMinutes }}</small>
                    </div>
                  </div>
                </div>
                <!-- Department Performance -->
                <div class="col-sm-6 col-xl-3 mb-2 mb-sm-0">
                  <div class="media">
                    <div class="avatar bg-light-primary mr-2">
                      <div class="avatar-content">
                        <i data-feather="bar-chart" class="avatar-icon"></i>
                      </div>
                    </div>
                    <div class="media-body my-auto">
                      <h4 class="font-weight-bolder mb-0">{{ departmentStats[0]?.successRate | percent:'1.0-2' }}</h4>
                      <p class="card-text font-small-3 mb-0">Success Rate</p>
                      <small>Avg Handling: {{ departmentStats[0]?.avgHandlingTime | msToMinutes }}</small>
                    </div>
                  </div>
                </div>
                <!-- Today's Stats -->
                <div class="col-sm-6 col-xl-3">
                  <div class="media">
                    <div class="avatar bg-light-success mr-2">
                      <div class="avatar-content">
                        <i data-feather="activity" class="avatar-icon"></i>
                      </div>
                    </div>
                    <div class="media-body my-auto">
                      <h4 class="font-weight-bolder mb-0">{{ dailyStats[0]?.totalCalls || 0 }}</h4>
                      <p class="card-text font-small-3 mb-0">Today's Calls</p>
                      <small>Success: {{ dailyStats[0]?.successfulCalls || 0 }}</small><br>
                      <small>Failed: {{ dailyStats[0]?.failedCalls || 0 }}</small>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <!--/ Analytics Cards -->
      <!-- Admin Department Stats Table -->
      <div class="col-xl-12 col-md-12 col-12 mt-2" *ngIf="isAdmin && departmentStats.length">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Department Stats</h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Department</th>
                    <th>Total Users</th>
                    <th>Active Users</th>
                    <th>Online Users</th>
                    <th>Total Calls</th>
                    <th>Success Rate</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let dept of departmentStats">
                    <td>{{ dept.name }}</td>
                    <td>{{ dept.userStats?.total }}</td>
                    <td>{{ dept.userStats?.active }}</td>
                    <td>{{ dept.userStats?.online }}</td>
                    <td>{{ dept.callStats?.total }}</td>
                    <td>{{ dept.callStats?.successRate | percent:'1.0-2' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Agent Department Stats Table -->
      <div class="col-xl-12 col-md-12 col-12 mt-2" *ngIf="!isAdmin && departmentStats.length">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Department Performance</h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Total Calls</th>
                    <th>Successful Calls</th>
                    <th>Failed Calls</th>
                    <th>Avg Call Duration</th>
                    <th>Avg Handling Time</th>
                    <th>Success Rate</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let dept of departmentStats">
                    <td>{{ dept.totalCalls }}</td>
                    <td>{{ dept.successfulCalls }}</td>
                    <td>{{ dept.failedCalls }}</td>
                    <td>{{ dept.avgCallDuration | msToMinutes }}</td>
                    <td>{{ dept.avgHandlingTime | msToMinutes }}</td>
                    <td>{{ dept.successRate | percent:'1.0-2' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Admin Daily Call Stats Table -->
      <div class="col-xl-12 col-md-12 col-12 mt-2" *ngIf="isAdmin && dailyCallStats.length">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Daily Call Stats</h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Total Calls</th>
                    <th>Successful Calls</th>
                    <th>Failed Calls</th>
                    <th>Avg Call Duration</th>
                    <th>Max Call Duration</th>
                    <th>Total Duration</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let stat of dailyCallStats">
                    <td>{{ stat.date | date:'mediumDate' }}</td>
                    <td>{{ stat.totalCalls }}</td>
                    <td>{{ stat.successfulCalls }}</td>
                    <td>{{ stat.failedCalls }}</td>
                    <td>{{ stat.avgCallDuration | msToMinutes }}</td>
                    <td>{{ stat.maxCallDuration | msToMinutes }}</td>
                    <td>{{ stat.totalDuration | msToMinutes }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Agent Daily Stats Table -->
      <div class="col-xl-12 col-md-12 col-12 mt-2" *ngIf="!isAdmin && dailyStats.length">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Daily Performance History</h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Total Calls</th>
                    <th>Successful</th>
                    <th>Failed</th>
                    <th>Avg Duration</th>
                    <th>Max Duration</th>
                    <th>Total Duration</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let stat of dailyStats">
                    <td>{{ stat.date | date:'mediumDate' }}</td>
                    <td>{{ stat.totalCalls }}</td>
                    <td>{{ stat.successfulCalls }}</td>
                    <td>{{ stat.failedCalls }}</td>
                    <td>{{ stat.avgCallDuration | msToMinutes }}</td>
                    <td>{{ stat.maxCallDuration | msToMinutes }}</td>
                    <td>{{ stat.totalDuration | msToMinutes }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!--/ Statistics Card -->     

    </div>
    <!-- Basic Alerts end -->
  </div>
</div>